import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: media.Rendition.
export default class Rendition extends Fragment {
  declare [Type]: 'media/rendition';

  // size is a string representing the size, e.g. "thumb" or "100x100".
  @attr('string', { defaultValue: '' })
  declare size: string;

  // storageKey is the generated file name under which this rendition is
  // actually stored.
  @attr('string', { defaultValue: '' })
  declare storageKey: string;

  // width is the width of this rendition in pixels.
  @attr('number', { defaultValue: 0 })
  declare width: number;

  // height is the height of this rendition in pixels.
  @attr('number', { defaultValue: 0 })
  declare height: number;

  // fileSize is the size of this rendition in bytes.
  @attr('number', { defaultValue: 0 })
  declare fileSize: number;

  // mimeType optionally overrides the MediaMeta records' MimeType field,
  // i.e. for thumbnail images.
  @attr('string', { defaultValue: '' })
  declare mimeType: string;
}
